import qs from 'qs'
import { apiInterface } from '@/api/interfaces'
import AbstractApi from '@/api/abstract'
import { STATUS_TASK, STATUSES_TASK_OPENED } from '@/apps/Tasks/const'
import { taskApiReq, taskApiRes } from './interfaces'

export const toQueryString = (params: Record<string, string | string[]>): string => {
  const queryParams = new URLSearchParams()
  
  Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        const isStateParam = key === 'state'
        const hasAll = value.includes(STATUS_TASK[4].status)
        const hasOpened = value.includes(STATUS_TASK[5].status)
       value.forEach(v => {
        if(isStateParam && v === STATUS_TASK[5].status && !hasAll) {
          STATUSES_TASK_OPENED.forEach((el) => queryParams.append(key, el))
          return
        }
        if(isStateParam && hasAll) return
        if(isStateParam && STATUSES_TASK_OPENED.includes(v) && hasOpened) return
        queryParams.append(key, v)
      })
      } else if (value && key !== 'group') {
        queryParams.append(key, value)
      }
  })

  return queryParams.toString()
  }

class TaskApi implements apiInterface.ITaskApi {
  ctx: AbstractApi

  constructor(ctx: AbstractApi) {
    this.ctx = ctx
  }

  getTasks = async (params: taskApiReq.IGetTasksReq = {}): Promise<taskApiRes.IGetTasksRes> => {
    const groups = qs.stringify({ groups: params.groups }, { indices: false })
    const checkGroups = params.groups && params.isMine ? `?${groups}` : '?'

    const url = `/task/${checkGroups}${toQueryString(params as Record<string, string | string[]>)}`;

    const res = await this.ctx.get<taskApiReq.IGetTasksReq, taskApiRes.IGetTasksRes>(url)
    return res.data
  }

  createTask = async (params: taskApiReq.ICreateTaskReq | FormData): Promise<taskApiRes.ICreateTaskRes> => {
    const res = await this.ctx.post<taskApiReq.ICreateTaskReq | FormData, taskApiRes.ICreateTaskRes>(
      '/task/',params
    )
    return res.data
  }

  responseTask = async (
    id: number,
    params: taskApiReq.IResponseTaskReq
  ): Promise<taskApiRes.IResponseTaskRes> => {
    const res = await this.ctx.post<taskApiReq.IResponseTaskReq, taskApiRes.IResponseTaskRes>(
      `/task/${id}/task_response/`,
      params
    )
    return res.data
  }

  closeTask = async (id: number): Promise<taskApiRes.ICloseTaskRes> => {
    const res = await this.ctx.post<unknown, taskApiRes.ICloseTaskRes>(
      `/task/${id}/transition_close/`,
      {}
    )
    return res.data
  }

  startTask = async (id: number): Promise<taskApiRes.IStartTaskRes> => {
    const res = await this.ctx.post<unknown, taskApiRes.IStartTaskRes>(
      `/task/${id}/transition_start/`,
      {}
    )
    return res.data
  }

  getTypesTask = async (): Promise<taskApiRes.IGetTypesTaskRes[]> => {
    const res = await this.ctx.get<unknown, taskApiRes.IGetTypesTaskRes[]>('/task/task_types/')
    return res.data
  }

  getTasksCount = async (): Promise<taskApiRes.IGetTasksCountRes> => {
    const res = await this.ctx.get<unknown, taskApiRes.IGetTasksCountRes>('/task/tasks_count/')
    return res.data
  }

  removeTasks = async (task_list: number[]): Promise<void> => {
    await this.ctx.delete<unknown, void>('/task/multi_delete/',{}, {
      params: { task_list },
      paramsSerializer: (params: { task_list: number[] }) =>
        qs.stringify(params, { arrayFormat: 'comma' })
    })
  }
}

export default TaskApi
